export default function HuntClue() {
	return (
		<div
			dangerouslySetInnerHTML={{
				__html: '<!-- type /keepgoing to proceed to the next step. -->'
			}}
		/>
	)
}
